import { Container, Row, Col } from "react-bootstrap";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { experiences, education, languages } from "../data/content";
import { Tags } from "./Tags";

export const Experience = () => {
  return (
    <section className="experience" id="experiencia">
      <Container>
        <TrackVisibility once>
          {({ isVisible }) =>
          <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
            <h2>Experiência</h2>
            <p className="section-subtitle">Onde trabalhei e o que entreguei.</p>
            <Row>
              <Col lg={8}>
                <ol className="timeline">
                  {experiences.map((exp) => (
                    <li className="timeline-item" key={exp.company}>
                      <div className="timeline-header">
                        <h3>{exp.role} · <span className="company">{exp.company}</span></h3>
                        <span className="period">{exp.period}</span>
                      </div>
                      <p className="context">{exp.context}</p>
                      <ul>
                        {exp.highlights.map((h) => <li key={h}>{h}</li>)}
                      </ul>
                      <Tags items={exp.tags} />
                    </li>
                  ))}
                </ol>
              </Col>
              <Col lg={4}>
                <div className="education-bx">
                  <h3>Formação</h3>
                  {education.map((edu) => (
                    <div className="education-item" key={edu.school}>
                      <h4>{edu.school}</h4>
                      <p>{edu.course}</p>
                      <span className="period">{edu.period}</span>
                      {edu.notes.map((n) => <p className="award" key={n}>🏆 {n}</p>)}
                    </div>
                  ))}
                  <h3>Idiomas</h3>
                  <p>{languages}</p>
                </div>
              </Col>
            </Row>
          </div>}
        </TrackVisibility>
      </Container>
    </section>
  )
}
